function FullScreenHeader(){

    console.log("FullScreenHeader");

    var self = this;


    self.size = new BrowserSize();

    //1270 × 714

    function resizeImages(){

       // var ratio = $(window).width()/$(window).height();

        //var s = self.size.getWindowSize();

        var s = self.size.getWindowSize();

        var $img = $('.fullscreen-header .header-swiper img');

        var imageWidth = 1800;
        var imageHeight = 1012;

        var screenRatio =  s.width/s.height;

        var imageRatio = imageWidth / imageHeight;

        var newWidth;
        var newHeight;
        var left;

        if (screenRatio < 1){

            console.log("portrait");

            console.log("screen less than image");

            newWidth = s.height * imageRatio;

            console.log("imageRatio ", imageRatio);

            console.log("newWidth ", newWidth, " s.height ", s.height, " ratio ",  newWidth/s.height);
            left = -(newWidth - s.width) /2;

            TweenMax.set($img, {width: newWidth, height: s.height, left:left,  top:0});


        } else {


            console.log("landscape");



            if (screenRatio < imageRatio){

                console.log("screen less than image");

                newWidth = s.height * imageRatio;

                console.log("imageRatio ", imageRatio);

                console.log("newWidth ", newWidth, " s.height ", s.height, " ratio ",  newWidth/s.height);
                left = -(newWidth - s.width) /2;

                TweenMax.set($img, {width: newWidth, height: s.height, left:left,  top:0});


            } else {

                console.log("screen more than image");


                newHeight = s.width/ imageRatio;
                var top = -(newHeight - s.height) /2;

                console.log("imageRatio ", imageRatio);

                console.log("s.width ", s.width, " newHeight ", newHeight, " ratio ",  s.width/newHeight);

                TweenMax.set($img, {width: s.width ,height: newHeight, left:0,  top:top});

            }

            /*if (screenRatio < imageRatio){

                console.log("screenRatio less than image ratio");

                var newWidth = s.height* imageRatio;
                var left = -(newWidth - s.width) /2;

                console.log("nW "+ newWidth);

                TweenMax.set($img, {width: newWidth ,height: s.height, left:left,  top:0});

                // TweenMax.set(self.$video, {left:0});


            } else {

                console.log("wider");

                var newHeight = (s.width)/ imageRatio;
                var top = -(newHeight - s.height) /2;

                TweenMax.set($img, {width: s.width ,height: newHeight, left:0,  top:top});

                //TweenMax.set(self.$video, {left:0});

            }*/
        }

       /* if (screenRatio < imageRatio){

            console.log("screenRatio less than image ratio");

            var newWidth = s.height* imageRatio;
            var left = -(newWidth - s.width) /2;

            console.log("nW "+ newWidth);

            TweenMax.set($img, {width: newWidth ,height: s.height, left:left,  top:0});

           // TweenMax.set(self.$video, {left:0});


        } else {

            console.log("wider");

            var newHeight = (s.width)/ imageRatio;
            var top = -(newHeight - s.height) /2;

            TweenMax.set($img, {width: s.width ,height: newHeight, left:0,  top:top});

            //TweenMax.set(self.$video, {left:0});

        }*/

    }




    $(window).resize(function (){

        console.log("resize");

        resizeImages();


    });

    resizeImages();

    //var fullScreenHeader = new FullScreenHeader()

    /*var $img = $('.header-swiper img'),
     imageWidth = $img[0].width, //need the raw width due to a jquery bug that affects chrome
     imageHeight = $img[0].height, //need the raw height due to a jquery bug that affects chrome
     maxWidth = $(window).width(),
     maxHeight = $(window).height(),
     widthRatio = maxWidth / imageWidth,
     heightRatio = maxHeight / imageHeight;

     var ratio = widthRatio; //default to the width ratio until proven wrong

     if (widthRatio * imageHeight > maxHeight) {
     ratio = heightRatio;
     }


     //now resize the image relative to the ratio
     $img.attr('width', imageWidth * ratio)
     .attr('height', imageHeight * ratio);

     //and center the image vertically and horizontally
     $img.css({
     margin: 'auto',
     position: 'absolute',
     top: 0,
     bottom: 0,
     left: 0,
     right: 0
     });*/


}
